<template>
  <div class="vehicleFaultRecord-container">
    <el-form :model="queryForm" inline ref="queryForm">
      <el-form-item class="r-20" prop="plateNum">
        <el-input
          v-model.trim="queryForm.plateNum"
          placeholder="请输入车牌号"
          @keyup.enter.native="query"
        ></el-input>
      </el-form-item>
      <el-form-item class="r-20" prop="faultCode">
        <el-input
          v-model.trim="queryForm.faultCode"
          placeholder="请输入故障码"
          @keyup.enter.native="query"
        ></el-input>
      </el-form-item>
      <el-form-item class="r-20" prop="model">
        <el-select v-model.trim="queryForm.model" placeholder="请选择厂商型号">
          <el-option
            v-for="item in modelList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="r-20" prop="handleType">
        <el-select
          v-model.trim="queryForm.handleType"
          placeholder="请选择处理类型"
        >
          <el-option
            v-for="item in handleTypeList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="r-20" prop="handlePercent">
        <el-select
          v-model.trim="queryForm.handlePercent"
          placeholder="请选择处理进度"
        >
          <el-option
            v-for="item in handlePercentsList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="r-20" prop="startTime" label="发生时间：">
        <date-picker
          :startTime="happenStartTime"
          :endTime="happenEndTime"
          @changeStart="happenStart"
          @changeEnd="happenEnd"
        >
        </date-picker>
      </el-form-item>
      <el-form-item class="r-20" prop="handleTime" label="处理时间：">
        <date-picker
          :startTime="handleStartTime"
          :endTime="handleEndTime"
          @changeStart="handleStart"
          @changeEnd="handleEnd"
        >
        </date-picker>
      </el-form-item>
      <el-form-item class="r-20" prop="completeTime" label="完成时间：">
        <date-picker
          :startTime="completeStartTime"
          :endTime="completeEndTime"
          @changeStart="completeStart"
          @changeEnd="completeEnd"
        >
        </date-picker>
      </el-form-item>
      <el-form-item class="r-20" prop="type">
        <el-select v-model.trim="queryForm.type" placeholder="请选择故障类型">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="r-20" prop="deviceName">
        <el-input
          v-model.trim="queryForm.deviceName"
          placeholder="请输入故障设备名称"
          @keyup.enter.native="query"
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="query">查询</el-button>
      <el-button @click="reset">取消</el-button>
      <div style="margin-bottom: 20px">
        <el-button type="primary" @click="addDefault()">新增</el-button>
      </div>
    </el-form>
    <el-table :data="tableData" height="584px" size="mini">
      <el-table-column
        align="center"
        label="车牌号"
        prop="plateNum"
        min-width="120"
        fixed="left"
      ></el-table-column>
      <el-table-column
        align="center"
        label="车架号"
        prop="vin"
        min-width="180"
        fixed="left"
      ></el-table-column>
      <el-table-column
        align="center"
        label="车型"
        prop="vehicleModel"
        min-width="120px"
      ></el-table-column>
      <el-table-column
        align="center"
        label="厂商型号"
        prop="manufacturerModel"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="车企名称"
        prop="carCompanyName"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="车辆绑定人"
        prop="personnelName"
      ></el-table-column>
      <el-table-column align="center" label="故障类型" fixed="left">
        <template slot-scope="{ row }">
          <span v-if="row.errorType == 0">配件故障</span>
          <span v-else-if="row.errorType == 1">其他故障</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="故障设备（配件）名称"
        prop="errorEquipment"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="故障码"
        prop="faultCode"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="配件规格"
        prop="partSpecification"
        min-width="100px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="发生地点"
        prop="scene"
        show-overflow-tooltip
        min-width="140px"
      ></el-table-column>
      <el-table-column
        align="center"
        label="发生时间"
        prop="occurrenceTime"
        min-width="160px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="（预）处理时间"
        prop="handlingTime"
        min-width="160px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="故障现象描述"
        prop="errorDescription"
        show-overflow-tooltip
        min-width="140px"
      ></el-table-column>
      <el-table-column
        align="center"
        label="完成时间"
        prop="completeTime"
        min-width="160px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column align="center" label="上次（安装）处理人员信息">
        <el-table-column
          align="center"
          label="姓名"
          prop="lastHandlerName"
        ></el-table-column>
        <el-table-column
          align="center"
          label="电话"
          min-width="140"
          prop="lastHandlerPhone"
        ></el-table-column>
        <el-table-column
          align="center"
          label="单位"
          prop="lastHandlerCompany"
          min-width="140px"
          show-overflow-tooltip
        ></el-table-column>
      </el-table-column>
      <el-table-column align="center" label="本次处理人员信息">
        <el-table-column
          align="center"
          label="姓名"
          prop="handlerName"
        ></el-table-column>
        <el-table-column
          align="center"
          label="电话"
          min-width="140"
          prop="handlerPhone"
        ></el-table-column>
        <el-table-column
          align="center"
          label="单位"
          prop="handlerCompany"
          min-width="140px"
          show-overflow-tooltip
        ></el-table-column>
      </el-table-column>
      <el-table-column align="center" label="处理类型">
        <template slot-scope="{ row }">
          <span v-if="row.handlingType == 0">维修</span>
          <span v-else-if="row.handlingType == 1">更换</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="处理方式">
        <template slot-scope="{ row }">
          <span v-if="row.handlingMode == 0">到店处理</span>
          <span v-else-if="row.handlingMode == 1">返厂处理</span>
          <span v-else-if="row.handlingMode == 2">上门处理</span>
          <span v-else-if="row.handlingMode == 3">其他处理</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="处理进度">
        <template slot-scope="{ row }">
          <span v-if="row.handlingProgress == 0">待处理</span>
          <span v-else-if="row.handlingProgress == 1">处理中</span>
          <span v-else-if="row.handlingProgress == 2">处理完成</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="解决方法"
        prop="solution"
        min-width="120px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="录入人"
        prop="actorName"
      ></el-table-column>
      <el-table-column
        align="center"
        label="录入时间"
        prop="addTime"
        min-width="160px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="操作"
        fixed="right"
        min-width="220"
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="editVehicleDefault(row)"
            >编辑</el-button
          >
          <el-button type="text" @click="deleteDefault(row.id)">删除</el-button>
          <el-button type="text" @click="checklist(row.id)">清单</el-button>
          <el-button type="text" @click="clickBill(row.id)">票据</el-button>
          <el-button type="text" @click="appendix(row.id)">附件查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新增/编辑故障弹框 -->
    <el-dialog
      :title="addOrAditTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <add-or-adit-vehicle-default
        :closeDialog="dialogVisible"
        :editId="editRowData"
        :edit="editFlg"
        :autocomplete="autocomplete"
        @close="cancelDialog"
      ></add-or-adit-vehicle-default>
    </el-dialog>
    <!-- 清单 / 票据弹框 -->
    <el-dialog
      :title="checkTitle"
      :visible.sync="checkDialogVisible"
      class="bill-img"
    >
      <ul v-if="isList == 1">
        <li v-for="(url, i) in checkSrcList" :key="i + url" class="video-list">
          <el-image :src="url" lazy :preview-src-list="checkSrcList"></el-image>
        </li>
        <div v-if="checkSrcList.length == 0" class="image-noData">
          无数据
        </div>
      </ul>
      <ul v-else-if="isList == 2">
        <li v-for="(url, i) in billSrcList" :key="i + url" class="video-list">
          <el-image :src="url" lazy :preview-src-list="billSrcList"></el-image>
        </li>

        <div v-if="billSrcList.length == 0" class="image-noData">
          无数据
        </div>
      </ul>
    </el-dialog>
    <!-- 附件弹框 -->
    <el-dialog
      :visible.sync="appendixDialogVisible"
      class="appendix-style"
      @close="videoPause()"
    >
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="处理前故障查看" name="first">
          <ul v-if="appendixVideoUrl.length != 0">
            <li
              v-for="(url, index) in appendixVideoUrl"
              :key="index + url"
              class="video-list"
            >
              <video width="100%" controls :src="url" ref="vueRef"></video>
            </li>
          </ul>
          <ul v-if="prevHandleFileList.length != 0">
            <li
              v-for="(url, index) in prevHandleFileList"
              :key="index + url"
              class="video-list"
            >
              <el-image
                :src="url"
                lazy
                :preview-src-list="prevHandleFileList"
              ></el-image>
            </li>
          </ul>
          <div
            v-if="
              prevHandleFileList.length == 0 && appendixVideoUrl.length == 0
            "
            class="image-noData"
          >
            无数据
          </div>
        </el-tab-pane>
        <el-tab-pane label="处理后故障查看" name="second">
          <ul v-if="appendixResultVideoUrl.length != 0">
            <li
              v-for="(url, index) in appendixResultVideoUrl"
              :key="index + url"
              class="video-list"
            >
              <video width="100%" controls :src="url" ref="vueRef1"></video>
            </li>
          </ul>
          <ul v-if="handleFileList.length != 0">
            <li
              v-for="(url, index) in handleFileList"
              :key="index + url"
              class="video-list"
            >
              <el-image :src="url" lazy :preview-src-list="handleFileList">
              </el-image>
            </li>
          </ul>
          <div
            v-if="
              handleFileList.length == 0 && appendixResultVideoUrl.length == 0
            "
            class="image-noData"
          >
            无数据
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import AddOrAditVehicleDefault from "@/views/Vehicle/VehicleFaultRecord/components/AddOrAditVehicleDefault.vue";
export default {
  name: "VehicleFaultRecord",
  components: {
    DatePicker,
    AddOrAditVehicleDefault,
  },
  data() {
    return {
      queryForm: {
        plateNum: "",
        type: "",
        handleType: "",
        handlePercent: "",
        startTime: "",
        handleTime: "",
        completeTime: "",
        model: "",
        deviceName: "",
        faultCode: "",
      },
      autocomplete: false,
      activeName: "first",
      activeId: null,
      appendixType: 2,
      currentPage: 1,
      limit: 10,
      total: 0,
      addOrAditTitle: "",
      happenStartTime: "",
      happenEndTime: "",
      handleStartTime: "",
      handleEndTime: "",
      completeStartTime: "",
      completeEndTime: "",
      dialogVisible: false,
      editFlg: false,
      editRowData: null,
      isList: 1,
      checkTitle: "",
      checkDialogVisible: false,
      checklistImage: "",
      checkSrcList: [],
      billSrcList: [],
      appendixDialogVisible: false,
      appendixVideoUrl: [],
      appendixResultVideoUrl: [],
      prevHandleFileList: [],
      handleFileList: [],
      handlePercentsList: [
        { id: 0, label: "待处理", value: "0" },
        { id: 1, label: "处理中", value: "1" },
        { id: 2, label: "处理完成", value: "2" },
      ],
      handleTypeList: [
        { id: 0, label: "维修", value: "0" },
        { id: 1, label: "更换", value: "1" },
      ],
      modelList: [
        { id: 1, label: "牡丹MD5026XDY型电源车", value: 1 },
        { id: 2, label: "牡丹MD5036XDYBEV纯电动电源车", value: 2 },
        { id: 3, label: "中汽ZQZ5026XDYSC6电源车", value: 3 },
      ],
      typeList: [
        { id: 0, label: "配件故障", value: "0" },
        { id: 1, label: "其他故障", value: "1" },
      ],
      tableData: [],
    };
  },
  created() {
    this.getFaultRecordList();
  },
  methods: {
    // 弹框关闭回调【暂停视频播放】
    videoPause() {
      if (this.$refs.vueRef && this.$refs.vueRef.length > 0) {
        this.$refs.vueRef[0].pause();
      }
      if (this.$refs.vueRef1 && this.$refs.vueRef1.length > 0) {
        this.$refs.vueRef1[0].pause();
      }
    },
    handleClick(tab) {
      this.appendixResultVideoUrl = [];
      this.handleFileList = [];
      this.activeName = tab.name;
      if (this.activeName == "first") {
        this.appendixType = 2;
      } else if (this.activeName == "second") {
        this.appendixType = 3;
      } else {
        this.$message.warning("系统错误！");
      }
      this.getFileList(this.activeId, this.appendixType);
    },
    checklist(id) {
      this.checkTitle = "查看清单";
      this.checkDialogVisible = true;
      this.isList = 1;
      this.getFileList(id, "0");
    },
    clickBill(id) {
      this.checkTitle = "查看票据";
      this.checkDialogVisible = true;
      this.isList = 2;
      this.getFileList(id, 1);
    },
    // 处理拿到的文件url数据
    changFile(urlList) {
      let videoList = [...urlList];
      let imgList = [...urlList];
      let typeVideoList = [];
      let typeImgList = [];
      // 过滤得到视频文件
      typeVideoList = videoList.filter((item) => item.match(/([Mm][Pp]4)$/g));
      // 过滤得到图片文件
      typeImgList = imgList.filter((item) => item.match(/(jpg|jpeg|png)/gi));
      return { typeVideoList, typeImgList };
    },
    async getFileList(id, type) {
      let { data: res } = await this.$axios.get(
        "/api/error/recording/selectImg",
        {
          params: {
            id: id,
            type: type,
          },
        }
      );
      if (res.code == 1) {
        if (type === "0") {
          this.checkSrcList = res.data;
        } else if (type == 1) {
          this.billSrcList = res.data;
        } else if (type == 2) {
          let { typeVideoList: video, typeImgList: img } = this.changFile(
            res.data
          );
          this.appendixVideoUrl = video;
          this.prevHandleFileList = img;
        } else if (type == 3) {
          let { typeVideoList: video1, typeImgList: img1 } = this.changFile(
            res.data
          );
          this.appendixResultVideoUrl = video1;
          this.handleFileList = img1;
        }
      }
    },
    async appendix(id) {
      // 重置数据
      this.activeName = this.$options.data().activeName;
      this.appendixVideoUrl = [];
      this.prevHandleFileList = [];
      this.activeId = id;
      this.getFileList(id, 2);
      this.appendixDialogVisible = true;
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.happenStartTime = "";
      this.happenEndTime = "";
      this.handleStartTime = "";
      this.handleEndTime = "";
      this.completeStartTime = "";
      this.completeEndTime = "";
      this.getFaultRecordList();
    },
    cancelDialog() {
      this.dialogVisible = false;
      // 刷新分页数据
      this.getFaultRecordList();
    },
    // 新增车辆故障记录
    addDefault() {
      this.addOrAditTitle = "新增车辆故障记录";
      this.editFlg = false;
      // 清空数据放在子组件中执行，否则会改变数据触发校验
      this.editRowData = -1;
      setTimeout(() => {
        this.dialogVisible = true;
      }, 300);
      // 弹框打开禁止用户输入
      this.autocomplete = true;
    },
    // 修改车辆故障记录
    editVehicleDefault(row) {
      this.addOrAditTitle = "修改车辆故障记录";
      this.$emit("getVehicleId", row.id);
      this.editRowData = row.id;
      this.editFlg = true;
      setTimeout(() => {
        this.dialogVisible = true;
      }, 300);
      // 弹框打开禁止用户输入
      this.autocomplete = true;
    },
    // 删除功能
    deleteDefault(id) {
      let ids = [];
      ids = [id];
      console.log("deleteDefault");
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 删除接口
          let { data: res } = await this.$axios.delete(
            "/api/error/recording/delete?ids=" + ids
          );
          if (res.code == 1) {
            this.$message({ type: "success", message: "删除成功!" });
            this.getFaultRecordList();
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    query() {
      this.getFaultRecordList();
    },
    async getFaultRecordList() {
      let _this = this;
      let obj = {};
      obj.plateNum = _this.queryForm.plateNum;
      obj.manufacturerModel = _this.queryForm.model;
      obj.handlingType = _this.queryForm.handleType;
      obj.handlingProgress = _this.queryForm.handlePercent;
      obj.errorType = _this.queryForm.type;
      obj.faultCode = _this.queryForm.faultCode;
      obj.errorEquipment = _this.queryForm.deviceName;
      obj.handlingStart = _this.handleStartTime;
      obj.handlingEnd = _this.handleEndTime;
      obj.occurrenceStart = _this.happenStartTime;
      obj.occurrenceEnd = _this.happenEndTime;
      obj.completeStart = _this.completeStartTime;
      obj.completeEnd = _this.completeEndTime;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get(
        "/api/error/recording/listAll",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getFaultRecordList();
    },
    happenStart(val) {
      this.happenStartTime = val;
    },
    happenEnd(val) {
      this.happenEndTime = val;
    },
    handleStart(val) {
      this.handleStartTime = val;
    },
    handleEnd(val) {
      this.handleEndTime = val;
    },
    completeStart(val) {
      this.completeStartTime = val;
    },
    completeEnd(val) {
      this.completeEndTime = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.vehicleFaultRecord-container {
  height: calc(100% - 80px);
  padding: 20px;
  margin: 20px;
  background: #fff;
  /deep/ .el-table {
    border: none;
    th {
      padding: 4px 0;
      background: #f3f3f3;
      border: 0.5px solid #d7d7d7;
    }
    td {
      border: 0.5px solid #d7d7d7;
    }
  }
  /deep/ .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #fff;
  }
  /deep/ .el-table__fixed-right {
    box-shadow: none;
  }
  /deep/ .el-dialog {
    min-width: 780px;
  }
  /deep/ .el-tabs__nav {
    z-index: 0;
  }
  /deep/ .el-tabs__content {
    max-height: 999px;
    overflow: scroll;
  }
  .appendix-style {
    /deep/ .el-dialog__body {
      padding: 30px 0 0 0 !important;
      .el-tabs--border-card {
        border: none;
        box-shadow: none;
        .el-tabs__header {
          border: none;
          background: #f2f2f2;
          .el-tabs__nav {
            width: 100%;
            .el-tabs__item {
              width: 50%;
              border: none;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .video-list {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
  .bill-img {
    /deep/ .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-height: 950px;
      overflow: scroll;
    }
  }
  .image-noData {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 200px;
    min-height: 200px;
    font-size: 20px;
    color: gray;
  }
}
</style>
